import React, { useEffect, useState } from 'react';
import './Home.css';
import useReviews from '../../hooks/useReviews/useReviews';
import BtnLink from '../BtnLink/BtnLink';




const Home = () => {
    const [reviews, setReviews] = useReviews();
    const topReviews = reviews.slice(0, 3);
    const [img, setImg] = useState([]);

    useEffect(() => {
        fetch('banner.json')
            .then(res => res.json())
            .then(data => setImg(data))
    }, [])
    // console.log(img)
    return (
        <div className='home-container'>
            <div className='home-head'>
                <div>

                    <h1 className='h1-frnd'>There is no <span>Friend</span> like as a Book</h1>
                    <h1 className='h1-best'>So, Book should be Our <span>Best Friend</span></h1>
                    <p> Everybody wants to get a friend who will help us when we have to take a decision properly but at this present World it is hard to find a decision maker friend without Book. Though every people are so busy and do not help us that is no way to worry cause We have book. Each book help us to build our knowledge and properly help us to take best decision. So, We can call book our best friend. Let's start to read book ... </p>
                   
                   
                </div>
                <div>

                    {img.map(pic => <img className='top-img' src={pic.img} alt="book-banner" />)}
                </div>
                <div className="btn-position">
                    <BtnLink to="/books">Choose a Book</BtnLink>
                    </div>
            </div>
        <hr />
            <div>
                <h1  className='h1-best book-RV'>Latest three Book Reviews: </h1>
                {topReviews.map(review => <div>
                    <div className='review-head'><img className='profile-img' src={review.img} alt={`profile pic of - ${review.name}`} />
                        <h1>{review.name}</h1>
                    </div>
                    <p>{review.reviewText}</p>
                    <h3> <span>User Ratings: </span><small>{review.rating}</small></h3>
                </div>)}
              <div className='btn-position'>  <BtnLink to="/reviews"> See All Reviews</BtnLink></div>
            </div>

        </div>
    );
};

export default Home;